import { forwardRef, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { StyledTable } from "./SummaryTable";
import useFormatters from "./useFormaters";

const SummaryAddonTable = forwardRef(({ vizInfo }, ref) => {
  const { t, i18n } = useTranslation("translation");
  const { formatDate } = useFormatters();

  if (!vizInfo) {
    return <div>No data</div>;
  }

  return (
    <>
      <StyledTable ref={ref}>
        <colgroup>
          <col className="col-first" />
          <col className="col-date" />
          <col className="" />
        </colgroup>
        <thead>
          <tr>
            <th className="title">{t("Deal")}</th>
            <th className="title">{t("Date of initial investment")}</th>
            <th className="title">{t("Valuation justification")}</th>
          </tr>
          <tr className="spacer-row">
            <td>&nbsp;</td>
          </tr>
        </thead>
        <tbody>
          {vizInfo.tree.by_fund.map((fundNode, fundIndex) => (
            <Fragment key={fundIndex}>
              {fundNode.by_deal_status.map((statusNode, statusIndex) => (
                <Fragment key={statusIndex}>
                  {statusNode.by_round_type.map(
                    (roundTypeNode, roundTypeIndex) => (
                      <Fragment key={roundTypeIndex}>
                        {roundTypeNode.by_deal.map((dealNode, dealIndex) => (
                          <tr className="deal-row" key={dealIndex}>
                            <td className="text-start">
                              {dealNode.portfolio.overriden_deal_name}
                            </td>
                            <td className="text-center">
                              {formatDate(
                                dealNode.portfolio.initial_investment_date,
                              )}
                            </td>
                            <td className="text-start">
                              {dealNode.portfolio.valuation_justification || ""}
                            </td>
                          </tr>
                        ))}
                      </Fragment>
                    ),
                  )}
                </Fragment>
              ))}
            </Fragment>
          ))}
        </tbody>
      </StyledTable>
    </>
  );
});

export default SummaryAddonTable;
